<template>
  <el-dialog title="编辑线索" v-model="updateDialog" width="1100px">
    <div style="padding-right: 30px;height: 300px">
      <el-form :rules="updateRules" ref="updateRules" :model="updateItem">
        <el-row>
          <el-col :span="6">
            <el-form-item label="客户姓名" prop="name" label-width="100px">
              <el-input  v-model="updateItem.name" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户电话" prop="phone" disabled label-width="100px">
              <el-input v-model="updateItem.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="所属城市" prop="areaId" label-width="100px">
              <el-select v-model="updateItem.areaId">
                <el-option v-for="(item) in areaList" :label="item.name" :value="item.id" :key="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="城市类型" prop="flag" label-width="100px">
              <el-select v-model="updateItem.flag" placeholder="请选择类型" clearable>
                <el-option label="全部" :value="0"></el-option>
                <el-option label="中招" :value="1"></el-option>
                <el-option label="少年" :value="2"></el-option>
                <el-option label="高考" :value="4"></el-option>
                <el-option label="幼儿" :value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户来源" prop="source" label-width="100px">
              <el-select v-model="updateItem.source" placeholder="请选择客户来源">
                <el-option v-for="(item) in sourceList" :label="item.dictLabel" :value="item.dictValue*1" :key="item.dictValue" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户类型" prop="custTypeId" label-width="100px">
              <el-select v-model="updateItem.custTypeId" placeholder="请选择客户类型">
                <el-option v-for="(item) in custTypeList" :label="item.dictLabel" :value="item.dictValue*1" :key="item.dictValue" />
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button type="primary" @click="create">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {selectArea,updateThread} from '@/api/partner.js'
import {selectDictByType} from '@/api/dict.js'
export default {
  name: "UpdateThread",
  data() {
    return {
      updateDialog:false,
      updateItem:{

      },
      updateRules: {
        name: [{
          required: true,
          message: '请输入线索名称！',
          trigger: 'change'
        },],
        phone: [
          {required: true,message: '请输入联系电话！',trigger: 'change'},
          {pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur",}],
        areaId: [{
          required: true,
          message: '请选择所属城市！',
          trigger: 'change'
        }],
        flag: [{
          required: true,
          message: '请选择城市类型！',
          trigger: 'change'
        }],
        source: [{
          required: true,
          message: '请选择所属来源！',
          trigger: 'change'
        }],
        custTypeId: [{
          required: true,
          message: '请选择客户类型！',
          trigger: 'change'
        }],
      },
    }
  },
  methods:{
    openDialog(item){
      this.updateItem = item;
      this.updateDialog = true;
    },
    create(){
      this.$refs['updateRules'].validate((valid) => {
        if (valid){
          updateThread(this.updateItem).then(res=>{
            if(res.code == 200){
              this.$emit('succeed');
              this.updateDialog = false;
              this.$message.success("编辑成功");
            }else {
              this.$message.error(res.message);
            }
          })
        }
      })
    }
  },
  created() {
    selectDictByType('crmSource').then(res=>{
      if(res.code ==200){
        this.sourceList = res.data;
      }
    })
    selectDictByType('custType').then(res=>{
      if(res.code == 200){
        this.custTypeList = res.data;
      }
    })
    selectArea().then(res=>{
      this.areaList = res.data;
    })
  }
}
</script>

<style scoped>

</style>
